import React from 'react';
import {Link} from 'react-router-dom';
import '../assets/css/right-sidebar.css';
import HowToVideoThumb from '../assets/img/how-to-video-thumb.svg';
import Accordion from './Accordion';

const RightSidebar = (props)=> {
	const {data}=props;
	return (
		<aside className="p-4 right-sidebar mb-4">
      <iframe width="100%" height="300" src="https://www.youtube.com/embed/2GV1jMUWS7s?hl=en&cc_lang_pref=en&cc=1" title="Authbridge 100% paperless onboarding platform iBRIDGE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      {!!(data && data?.length) && <h3 className="fnt-bld mt-4 text-center">Frequently asked questions</h3>}
      <div className="accordian has-plus-minus" id="accordian" style={{marginTop : 48}}> 

	{data &&
    data.map((value, index) => {
		if(index===0){
        return (
            <Accordion 
			key={index}
	      	title={value.question}

	      	description={value.answer} 
	      	collapse="show" 
	      	ariaExpanded="true" 
	      	accordionNumber={index}
	      />
                

        )}
		else{
			return (
				<Accordion 
				key={index}
				  title={value.question}
	
				  description={value.answer} 
				  headerStatus="collapsed" 
				  ariaExpanded="false" 
				  accordionNumber={index}
			  />
					
	
			)}
		}
    )}
	   {/*   <Accordion 
	      	title="Can i finish form in steps?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible." 
	      	collapse="show" 
	      	ariaExpanded="true" 
	      	accordionNumber="1"
	      />
	      <Accordion 
	      	title="Are you contact my current employee?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
	      	headerStatus="collapsed" 
	      	ariaExpanded="false" 
	      	accordionNumber="2"
	      />
	      <Accordion 
	      	title="what if i don’t have all documents?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
	      	headerStatus="collapsed" 
	      	ariaExpanded="false" 
	      	accordionNumber="3"
	      />
	      <Accordion 
	      	title="Will my date is safe & secure?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
	      	headerStatus="collapsed" 
	      	ariaExpanded="false" 
	      	accordionNumber="4"
	      />
	      <Accordion 
	      	title="Can i know status of verification?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
	      	headerStatus="collapsed" 
	      	ariaExpanded="false" 
	      	accordionNumber="5"
	      />
	      <Accordion 
	      	title="How do I change my account email?" 
	      	description="Yes, you can try us for free for 30 days. If you want, we’ll provide you with a free, personalized 30-minute onboarding call to get you up and running as soon as possible."
	      	headerStatus="collapsed" 
	      	ariaExpanded="false" 
	      	accordionNumber="6"
		/>*/}
      </div>
		</aside>
	);
}

export default RightSidebar;